// extracted by mini-css-extract-plugin
export default {"root":"HowItWorks_root__hSwWK","items":"HowItWorks_items__3UeZ6","item":"HowItWorks_item__Sxn01","icon":"HowItWorks_icon__nvoH+","text":"HowItWorks_text__SsJs2"};